import { createContext } from 'react';

export type BillingHeaderContextType = {
  billingHeader: BillingHeaderContextTo | undefined;
  billingQuote: BillingHeaderContextTo | undefined;
  modifyBillingHeader: (address: BillingHeaderContextTo) => void;
  modifyBillingQuote: (address: BillingHeaderContextTo | undefined) => void;
};

export const billingHeaderContext = createContext<
  BillingHeaderContextType | undefined
>(undefined);

export type BillingMode = 'business' | 'customer' | 'simulation' | 'none';

export type BillingHeaderContextTo = {
  billingAddress?: any[];
  cnpjNumber?: string;
  disableHeader?: boolean;
  hasIE?: boolean;
  resellerId?: number;
  resellerType?: string;
  selectedMode?: BillingMode;
  shipToProvince?: string;
  shipToUF?: string;
};
